import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import SettingsIcon from "@mui/icons-material/Settings";
import Avatar from "@mui/material/Avatar";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import Tooltip from "@mui/material/Tooltip";
import Settings from "@mui/icons-material/Settings";
import Logout from "@mui/icons-material/Logout";
import {
  Badge,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import Cart from "../pages/Cart";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

const NavbarMobile = () => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [anchorE2, setAnchorE2] = useState(null);
  const open2 = Boolean(anchorE2);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick2 = (event) => {
    setAnchorE2(event.currentTarget);
  };
  const handleClose2 = () => {
    setAnchorE2(null);
  };

  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleLogout = () => {
    localStorage.removeItem("username");
    Cookies.remove("userid");
    Cookies.remove("token");
    console.log("User Logged Out");
    navigate("/");
  };

  return (
    <div className="navbar-mobile">
      <nav>
        <p>Gourmet.</p>
        <div className="nav-items">
          <IconButton
            aria-label="show settings"
            color="inherit"
            onClick={toggleDrawer}
          >
            <Badge badgeContent="" color="error">
              <SettingsIcon />
            </Badge>
          </IconButton>
          <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer}>
            <List>
              <ListItem component={Link} to="/">
                <ListItemText primary="Home" />
              </ListItem>
              <ListItem component={Link} to="/menu">
                <ListItemText primary="Menu" />
              </ListItem>
              <ListItem component={Link} to="/contact">
                <ListItemText primary="Contact" />
              </ListItem>
            </List>
          </Drawer>
          <Tooltip title="Account settings">
            <IconButton onClick={handleClick} size="small">
              <Avatar sx={{ width: 32, height: 32 }}></Avatar>
            </IconButton>
          </Tooltip>
          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <Link to="/profile" id="profile-link">
              <MenuItem onClick={handleClose}>
                <Avatar /> {localStorage.getItem("username")}
              </MenuItem>
            </Link>
            <Divider />
            <MenuItem onClick={handleClose}>
              <Link to="/wishlist" className="menu-links" id="wishlist-icon">
                <ListItemIcon>
                  <i className="fa-solid fa-heart"></i>
                </ListItemIcon>
                Wishlist
              </Link>
            </MenuItem>
            <MenuItem onClick={handleClose}>
              <ListItemIcon>
                <Settings fontSize="small" />
              </ListItemIcon>
              Settings
            </MenuItem>
            <MenuItem onClick={handleLogout}>
              <ListItemIcon>
                <Logout fontSize="small" />
              </ListItemIcon>
              Logout
            </MenuItem>
          </Menu>
        </div>
      </nav>
    </div>
  );
};

export default NavbarMobile;
